import type { CSSProperties } from 'react';

// Each PandaAI Email mailbox has its own colour (accounts.color), in the four shades the app's
// --accent variables use: `accent` is the colour itself (the mailbox's initials badge in the
// sidebar, the tint on its unread rows in the list), `hover` a darker step, `bg` a pale wash (the
// initials on the badge) and `text` a dark shade that reads on that wash. One palette for all of
// it, so an unread row, its mailbox's badge and the email module's buttons always match. Teal's
// shades are the app-wide defaults in global.css.
export const ACCOUNT_COLORS: Record<string, { accent: string; hover: string; bg: string; text: string }> = {
  teal: { accent: '#1D9E75', hover: '#0F6E56', bg: '#E1F5EE', text: '#085041' },
  blue: { accent: '#378ADD', hover: '#185FA5', bg: '#E6F1FB', text: '#0C447C' },
  purple: { accent: '#7F77DD', hover: '#534AB7', bg: '#EEEDFE', text: '#3C3489' },
  coral: { accent: '#D85A30', hover: '#993C1D', bg: '#FAECE7', text: '#712B13' },
  amber: { accent: '#BA7517', hover: '#854F0B', bg: '#FAEEDA', text: '#633806' },
};

// The --accent variables pointed at one mailbox's colour, for a style prop: every var(--accent…)
// inside that element then wears it. An unknown or missing colour keeps teal.
export function accentVars(color?: string | null): CSSProperties {
  const c = ACCOUNT_COLORS[color || ''] || ACCOUNT_COLORS.teal;
  return { '--accent': c.accent, '--accent-hover': c.hover, '--accent-bg': c.bg, '--accent-text': c.text } as CSSProperties;
}

// A see-through wash of a '#rrggbb' colour: ('#1D9E75', 0.08) → 'rgba(29,158,117,0.08)'.
export function tint(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${n >> 16},${(n >> 8) & 255},${n & 255},${alpha})`;
}
